import React from 'react';
import store from "../../../../../../store";

import {setSQFTActiveButton} from "../../../../../../actions/sqftMenuFunctions";
import {SIDEBAR_SLAB_BUTTONS} from "../../../../constants";

const SlabConflictWarning = ({ conflict }) => {
  function handleAddSlabImage(conflict) {
    void conflict;
    //store.dispatch(setSQFTMenuOpened(SIDEBAR_SLAB_BUTTONS.loadSlab));
    store.dispatch(setSQFTActiveButton(SIDEBAR_SLAB_BUTTONS.loadSlab));
  }

  return (
    <div className="slab-conflict-warning">
      <div className="slab-conflict-warning__icon">
        {/* Warning icon illustration like in your screenshot */}
        {/*<img src="/path/to/slab-conflict-icon.svg" alt="Conflict" />*/}
      </div>

      <div className="slab-conflict-warning__content text-center">
        <p className="text-justify">
          The highlighted shapes have been assigned a different material
          than the countertop. To maintain accuracy in slab allocation, these
          shapes need to be added to their own separate slab.
        </p>

        <button
          className="ui-button3  modal-fix-button ui-button3--green"
          onClick={() => handleAddSlabImage(conflict)}
        >
          ADD A SLAB IMAGE OR PLACEHOLDER
        </button>
      </div>
    </div>
  );
};

export default SlabConflictWarning;
